import '../App.css';
import PaintingList from '../components/PaintingList';

function Collection() {
  return (
    <PaintingList />
  );
}

export default Collection;
